<template>
    <div class="home-page">
      <div class="header-bgfff bgfff">
        <Header></Header>
          <div class="nav">
            <div class="back" @click="back">
              <img width="80" src="../../static/images/back2.png" />
            </div>
          </div>
      </div>
        <div class="nav-list ac">
          <div class="nav-li" v-for="(item,index) in typeList" @click="getToNav(item)" :class="{'active':item.id==type}">
            {{item.title}}
          </div>
        </div>
		<div class="">
      <div class="content crfff ac por">
        <div class="list-content">
          <div class="home-block5" v-for="(item,index) in list" @click="getToDetail(item)">
            <img :src="item.cover_image" loading="lazy">
            <div class="">
              <span class="status-badge" :class="'status-' + item.status">
                {{ statusText(item.status) }}
              </span>
            </div>
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{item.title}}</div>
              </div>
              <div class="learn button">{{$t('Watch')}}></div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Intermediate_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:''
      }
    },
	created(){
    this.getUserLevel();
    this.getType();
	},
    methods: {
      back(){
        this.$router.push({path:'/',query: {}});
      },
      getToDetail(item){
        this.$router.push({path:'/IntermediateDetail',query: {id:item.id}});
      },
      getToNav(item){
        this.type = item.id
        this.getList();
      },
      getType(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/mooc/type',null,r =>{
          that.$parent.returnCode(r,function(){
            that.typeList = r.data
            that.type = r.data[0].id
            that.getList()
            that.$parent.loadModal(false);
          })
        })
      },
      getList(){
        let that = this
        let data = {
          "type_id":this.type
        }

        that.$parent.loadModal(true);
        that.$api.post('/api/mooc/list',data,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
      getUserLevel(){
        let that =this;
        that.$parent.loadModal(true);
        that.$api.post('/api/level/info',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.level = r.data.level;
            if (r.data.level < 2){
              that.$refs.levelDialog.showMaskFun();
            }
          });

        })
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/Intermediate.vue